import gsap from 'gsap';
import { device, withPlugins } from '@spon/plugins';

function getRandomArbitrary(min, max) {
	return Math.random() * (max - min) + min;
}

function ScrollWords({ node, plugins: { device } }) {
	let $listItems = [...node.querySelectorAll('li')];
	node.style.height = `${$listItems[0]?.clientHeight}px`;

	let listItemHeight = $listItems[0]?.clientHeight;

	let timeInterval = 3; // time to change

	function scrollUp() {
		listItemHeight = $listItems[0]?.clientHeight;

		timeInterval = getRandomArbitrary(1, 7);

		gsap
			.timeline()
			.to($listItems, {
				y: `-=${listItemHeight}px`,
				duration: 1,
				ease: 'expo.inOut',
			})
			.to($listItems[0], {
				y: `+=${listItemHeight * $listItems.length}px`,
				duration: 0,
			}); // the first to the end

		$listItems.push($listItems.shift()); // the first (shift) to the end (push) from the array

		// start endless run
		gsap.delayedCall(timeInterval, scrollUp);
	}

	// start the crossfade after next = 3 sec
	gsap.delayedCall(timeInterval, scrollUp);

	$listItems.forEach(item => {
		item.classList.remove('absolute', 'opacity-0');
	});

	document
		.getElementById('scroll-words-container')
		.classList.remove('opacity-0');

	device.resize(() => {
		$listItems = [...node.querySelectorAll('li')];

		node.style.height = `${$listItems[0]?.clientHeight}px`;

		gsap.set($listItems, {
			y: 0,
		});
	});

	return () => {};
}

export default withPlugins(device)(ScrollWords);


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
